export default "__VITE_ASSET__BEtPvM9e__";